import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface HeaderBoxProps {
  noBorder?: boolean;
}

export const OrderTableWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.general.lightGrey,
  borderRadius: theme.spacing(2),
  margin: theme.spacing(1, 0),
  width: '580px',
}));

export const OrderTableHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: '48px',
  bgcolor: theme.palette.general.lightGrey1,
}));

export const OrderTableContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(0, 1),
  borderRadius: theme.spacing(2),
}));

export const HeaderBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'noBorder',
})<HeaderBoxProps>(({ theme, noBorder }) => ({
  borderRight: noBorder ? 'none' : `1px solid ${theme.palette.general.lightGrey2}`,
  marginLeft: theme.spacing(1),
}));
